import type { IconData } from '@stacksjs/iconify-core'

export const contentRemoveFolder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h4l2 2h8v4.875A5.5 5.5 0 0 0 6.59 13H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 8a4 4 0 0 1 4 4a4 4 0 1 1-4-4m2 3.25h-4v1.5h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentRemoveFolder
